document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Mobile menu ---------- */
  var menuToggle = document.getElementById('MenuToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileNav.hidden;
      mobileNav.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------- Nav dropdown (click to toggle) ---------- */
  var navToggles = document.querySelectorAll('.site-nav__toggle');
  navToggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var item = btn.closest('.site-nav__item');
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.site-nav__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var t = openItem.querySelector('.site-nav__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.site-nav__item.is-open').forEach(function (openItem) {
      openItem.classList.remove('is-open');
      var t = openItem.querySelector('.site-nav__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.site-nav__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
      });
    }
  });

  /* ---------- Search toggle ---------- */
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('SearchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var isOpen = !searchBar.hidden;
      searchBar.hidden = isOpen;
      searchToggle.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartToggle = document.getElementById('CartToggle');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartDrawerOverlay');
  var cartClose = document.getElementById('CartDrawerClose');

  function openCartDrawer(e) {
    if (!cartDrawer) return;
    if (e) e.preventDefault();
    cartDrawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    document.body.style.overflow = '';
  }
  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);

  /* ---------- Quantity selectors (+/-) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('qty-plus') || e.target.classList.contains('qty-minus')) {
      var wrapper = e.target.closest('.qty-selector');
      var input = wrapper && wrapper.querySelector('input');
      if (!input) return;
      var min = parseInt(input.min || '0', 10);
      var value = parseInt(input.value || '0', 10) || 0;
      value = e.target.classList.contains('qty-plus') ? value + 1 : Math.max(min, value - 1);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Cart line quantity updates (AJAX) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('qty-input') && e.target.dataset.key) {
      var key = e.target.dataset.key;
      var quantity = parseInt(e.target.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); });
    }
  });

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-detail__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage && thumb.dataset.full) mainImage.src = thumb.dataset.full;
    });
  });

  /* ---------- Product variant selection ---------- */
  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  var variantIdInput = document.getElementById('ProductVariantId');
  if (variantsJsonEl && variantIdInput) {
    var variants = JSON.parse(variantsJsonEl.textContent || '[]');
    var selected = {};

    document.querySelectorAll('.option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.dataset.optionIndex;
        var group = btn.closest('.product-detail__option-values');
        group.querySelectorAll('.option-value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[index] = btn.dataset.value;

        var match = variants.find(function (v) {
          var opts = [v.option1, v.option2, v.option3];
          return Object.keys(selected).every(function (i) { return opts[i] === selected[i]; });
        });
        if (match) {
          variantIdInput.value = match.id;
          var priceEl = document.querySelector('.product-detail__price');
          if (priceEl && match.price != null) {
            priceEl.textContent = (match.price / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR', minimumFractionDigits: 0 });
          }
        }
      });
    });
  }

  /* ---------- AJAX add to cart ---------- */
  var productForm = document.querySelector('.product-detail__info form[action*="/cart/add"], .product-detail__info form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { productForm.submit(); });
    });
  }

  /* ---------- Product card quick add ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-card__quick-add');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.product-card__add-btn');
    var formData = new FormData(form);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        var cartCount = document.getElementById('CartCount');
        if (cartCount) { cartCount.textContent = cart.item_count; }
        if (btn) {
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          btn.disabled = false;
          setTimeout(function () {
            btn.textContent = 'Add to Bag';
            btn.classList.remove('is-added');
          }, 1800);
        }
      })
      .catch(function () { form.submit(); });
  });
});
